module.exports = __webpack_public_path__ + "img/rankinglist_ranking1.7fb5a6eb.png";